export var RoomStatus;
(function (RoomStatus) {
    RoomStatus["WAITING"] = "WAITING";
    RoomStatus["PLAYING"] = "PLAYING";
    RoomStatus["FINISHED"] = "FINISHED";
    RoomStatus["CANCELLED"] = "CANCELLED";
})(RoomStatus || (RoomStatus = {}));
export var RoomEvent;
(function (RoomEvent) {
    RoomEvent["PLAYER_JOINED"] = "PLAYER_JOINED";
    RoomEvent["PLAYER_LEFT"] = "PLAYER_LEFT";
    RoomEvent["GAME_STARTED"] = "GAME_STARTED";
    RoomEvent["GAME_ENDED"] = "GAME_ENDED";
    RoomEvent["NUMBER_CALLED"] = "NUMBER_CALLED";
    RoomEvent["PRIZE_CLAIMED"] = "PRIZE_CLAIMED";
    RoomEvent["PRIZE_VERIFIED"] = "PRIZE_VERIFIED";
    RoomEvent["CHAT_MESSAGE"] = "CHAT_MESSAGE";
})(RoomEvent || (RoomEvent = {}));
//# sourceMappingURL=room.enums.js.map